(() => {
  const root = document.documentElement;
  let updateFrame;

  const getVisibleAnnouncementHeight = () => {
    const announcementBar = document.querySelector('.utility-bar');

    if (!announcementBar || window.getComputedStyle(announcementBar).display === 'none') return 0;

    const bounds = announcementBar.getBoundingClientRect();
    const visibleTop = Math.max(0, bounds.top);
    const visibleBottom = Math.min(window.innerHeight, bounds.bottom);

    return Math.max(0, visibleBottom - visibleTop);
  };

  const updateSearchOffset = () => {
    updateFrame = undefined;
    root.style.setProperty('--bambu-search-top-offset', `${getVisibleAnnouncementHeight()}px`);
  };

  const scheduleSearchOffsetUpdate = () => {
    if (updateFrame) return;
    updateFrame = window.requestAnimationFrame(updateSearchOffset);
  };

  updateSearchOffset();
  window.addEventListener('resize', scheduleSearchOffsetUpdate);
  window.addEventListener('scroll', scheduleSearchOffsetUpdate, { passive: true });

  const announcementBar = document.querySelector('.utility-bar');
  if (announcementBar && 'ResizeObserver' in window) {
    new ResizeObserver(scheduleSearchOffsetUpdate).observe(announcementBar);
  }
})();
